
export enum Natureza {
  GENERICA = 'GENERICA',
  CIVEL = 'CIVEL',
  CRIMINAL = 'CRIMINAL',
  TRABALHISTA = 'TRABALHISTA',
  ELEITORAL = 'ELEITORAL',
  MILITAR = 'MILITAR',
  FISCAL = 'FISCAL',
  INDEFINIDA = 'INDEFINIDA'
}
